import React from 'react';
import { Box, Button, Heading, Link, Paragraph, styled } from 'bumbag';

import { Link as RouterLink } from '@medipass/react-core/router';

import medicareCardPlaceholder from 'legacy/images/medicare-card-placeholder.svg';
import medicareCardPlaceholderSmall from 'legacy/images/small-medicare-card-placeholder.svg';

import ConditionalWrap from '../../common/ConditionalWrap.tsx';
const SmallImage = styled.img`
  width: 56px;
  margin-top: -9px;
  margin-bottom: -8px;
`;
type Props = {
  buttonProps?: Record<string, any> | null | undefined;
  className?: string | null | undefined;
  isSmallImage?: boolean;
};
export default class AddMedicareDetails extends React.Component<Props> {
  static defaultProps = {
    buttonProps: null,
    className: null,
    isSmallImage: false,
  };
  render = () => {
    const { buttonProps, className, isSmallImage } = this.props;
    return (
      // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
      <Box className={className}>
        <Heading use="h6" fontWeight="semibold">
          Add your Medicare card
        </Heading>
        <Paragraph>Add your Medicare card to easily refund any relevant health payments.</Paragraph>
        <Box display="flex" justifyContent="center">
          {isSmallImage && <SmallImage src={medicareCardPlaceholderSmall} alt="Medicare card" />}
          {!isSmallImage && <img src={medicareCardPlaceholder} alt="Medicare card" />}
        </Box>
        <ConditionalWrap
          condition={!buttonProps}
          wrap={children => (
            // @ts-expect-error
            <Link use={RouterLink} to="/account/create-medicare-account/" textDecoration="none">
              {children}
            </Link>
          )}
        >
          <Button palette="secondary" marginTop="major-2" width="100%" {...buttonProps}>
            ADD MEDICARE CARD
          </Button>
        </ConditionalWrap>
      </Box>
    );
  };
}
